import Container = Phaser.GameObjects.Container;
import Scene = Phaser.Scene;
import BaseSound = Phaser.Sound.BaseSound;
import {Radio} from "@/scenes.ui/radio";
import CU from "@/utils/c-u";

export class RadioPanel extends Container {

    constructor(scene: Scene, x: number, y: number, selectSound: BaseSound | undefined, ids: any[], names: string[], selectedIndex: number,
                checkCallback: (id: any) => unknown) {
        super(scene);
        this.x = x * CU.S;
        this.y = y * CU.S;

        let xx = -30 * CU.S - (names.length - 1) * 80 * CU.S;
        let i = 0;

        let radios: Radio[] = [];

        for (let name of names) {
            let ii = i;
            let radio = new Radio(scene, xx, 0, selectSound, i === selectedIndex, names[i], () => {
                for (let r of radios) {
                    r.setChecked(false);
                }
                radio.setChecked(true);
                checkCallback(ids[ii]);
            });
            radios.push(radio);
            this.add(radio);
            xx += 160 * CU.S;
            i++;
        }
    }
}
